<template>
    <div class="sellsy-password-input">
        <ul class="rules flex-column fs-2 mb-2 mt-0">
            <li>
                <i class="el-icon-success" :class="hasCorrectLength ? 'green' : ''"></i>
                <span>{{
                    $l10n.__('Compris entre %(min)s et %(max)s caractères', {
                        min: minLength,
                        max: maxLength,
                    })
                }}</span>
            </li>
            <li>
                <i class="el-icon-success" :class="hasLowercase && hasUppercase ? 'green' : ''"></i>
                <span>{{ $l10n.__('Au moins 1 majuscule et 1 minuscule') }}</span>
            </li>
            <li>
                <i class="el-icon-success" :class="hasNumber ? 'green' : ''"></i>
                <span>{{ $l10n.__('1 chiffre') }}</span>
            </li>
        </ul>
        <el-input
            v-if="mode == 'edit'"
            v-model="currentValue"
            :type="type"
            :autosize="{ minRows: 2, maxRows: 10 }"
            resize="none"
            :readonly="readonly"
            :placeholder="placeholder"
        >
            <i
                slot="suffix"
                class="gray-80 pointer el-input__icon"
                :class="suffixIcon"
                @click="toggleShow"
            ></i>
        </el-input>
        <p v-else>
            {{ currentValue }}
        </p>
    </div>
</template>

<script>
import { minLengthPassword, maxLengthPassword } from '../forms/rules/Rules';

export default {
    props: {
        mode: {
            type: String,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: [Number, String, Boolean],
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            currentValue: this.value === null ? '' : this.value.replace(/<br\s*[\/]?>/gi, '\n'),
            showPassword: false,
            minLength: minLengthPassword(),
            maxLength: maxLengthPassword(),
        };
    },
    computed: {
        hasCorrectLength() {
            return (
                this.currentValue.length >= this.minLength &&
                this.currentValue.length <= this.maxLength
            );
        },
        hasMinLength() {
            return this.currentValue.length >= this.minLength;
        },
        hasMaxLength() {
            return this.currentValue.length <= this.maxLength;
        },
        hasNumber() {
            return /\d/.test(this.currentValue);
        },
        hasLowercase() {
            return /[a-z]/.test(this.currentValue);
        },
        hasUppercase() {
            return /[A-Z]/.test(this.currentValue);
        },
        isValid() {
            return (
                this.hasMinLength &&
                this.hasMaxLength &&
                this.hasNumber &&
                this.hasLowercase &&
                this.hasUppercase
            );
        },
        suffixIcon() {
            return !this.showPassword ? 'icon-eye-fillout' : 'icon-eye-no-fillout';
        },
        type() {
            return this.showPassword ? 'text' : 'password';
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit('input', this.currentValue);
            this.$emit('isValid', this.isValid);
        },
        value(newValue, oldValue) {
            if (newValue != oldValue) {
                this.currentValue = newValue;
            }
        },
    },
    created() {
        this.$emit('isValid', this.isValid);
    },
    methods: {
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.sellsy-password-input {
    input[type='password'].el-input__inner {
        &::placeholder {
            color: $gray-60 !important;
        }
    }
    .el-input__suffix {
        right: spacer(2);
        display: flex;
        align-items: center;

        .el-input__suffix-inner {
            display: flex;
            width: 14px;
        }
    }
}
</style>
